import { c as e } from "../../../index-34b1f277.js";
import { ContentCardAnatomy as i } from "./ContentCard.anatomy.es.js";
const { defineMultiStyleConfig: t } = e(i.keys), a = t({
  baseStyle: {
    root: {
      cursor: "pointer",
      position: "relative",
      transition: "all 0.1s ease-in-out",
      _hover: {
        "& .platform--container": {
          visibility: "visible",
          bottom: 0,
          transition: "all 0.1s ease-in-out"
        },
        "& .checkbox--container": {
          transition: "all 0.1s ease-in-out",
          visibility: "visible"
        },
        img: {
          filter: "brightness(0.9)",
          transition: "all 0.1s ease-in-out"
        }
      },
      outlineColor: "transparent",
      "&[data-selected='true']": {
        transition: "all 0.1s ease-in-out",
        outline: "16px solid",
        outlineColor: "secondary.25",
        outlineOffset: "-16px",
        borderRadius: "24px",
        overflow: "hidden",
        boxSizing: "border-box",
        _hover: {
          outlineColor: "secondary.100"
        }
      }
    },
    checkbox: {
      zIndex: "1",
      position: "absolute",
      right: "spacing-125",
      top: "spacing-125",
      padding: "spacing-100",
      visibility: "hidden",
      "&[data-selected='true']": {
        visibility: "visible"
      }
    },
    image: {
      borderRadius: "8px",
      objectFit: "cover",
      maxWidth: "100%",
      minWidth: "100%",
      verticalAlign: "bottom",
      transition: "all 0.1s ease-in-out",
      "&[data-selected='true']": {
        transition: "all 0.1s ease-in-out",
        padding: "16px",
        // inner border and outer border
        borderRadius: "calc(16px + 8px)"
      }
    },
    bottomBarContainer: {
      display: "flex",
      height: "size-500",
      alignItems: "center",
      zIndex: 1,
      visibility: "hidden",
      background: "rgba(255, 255, 255, 0.75)",
      borderBottomRadius: "lg",
      left: 0,
      bottom: "-30px",
      position: "absolute",
      paddingX: "4px",
      paddingY: "5px",
      width: "100%",
      "&[data-selected='true']": {
        display: "none"
      }
    },
    bottomBarContent: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      paddingX: "4px",
      height: "calc(100% - 30px)",
      justifyContent: "space-between",
      '&[data-name=""]': {
        justifyContent: "flex-end"
      }
    },
    name: {
      lineHeight: "18px"
    },
    fallbackContainer: {
      height: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "primary.50",
      borderRadius: "5px",
      textAlign: "center",
      boxSize: "100%"
    },
    fallbackAlertIcon: {
      color: "primary.600",
      boxSize: 6
    },
    fallbackTitle: {
      width: "84px",
      paddingTop: "spacing-25"
    },
    platformIcon: {
      boxSize: "size-300",
      '&[data-platform="youtube"]': {
        boxSize: "size-400"
      }
    }
  }
});
export {
  a as ContentCard
};
//# sourceMappingURL=ContentCard.es.js.map
